/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FileTypePresentationIcon16Solid = forwardRef('FileTypePresentationIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 5.125A2.875 2.875 0 1 0 10.875 8H8.25A.25.25 0 0 1 8 7.75V5.125Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.597 1.586A2 2 0 0 0 9.182 1H4.5A2.5 2.5 0 0 0 2 3.5v9A2.5 2.5 0 0 0 4.5 15h7a2.5 2.5 0 0 0 2.5-2.5V5.817a2 2 0 0 0-.586-1.414l-2.817-2.817ZM3.875 8a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0Z" })));
});
